import { API_REQUEST, GET_TENANT_PROFILE, RESET_TENANT_PROFILE } from "../../actionTypes/actionsTypes";
import { AppAction, AppNoApiAction } from "../../types";

export const downloadTenantProfile = (roll_num: string, lang: string): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/documents/tenant/${roll_num}/${lang}`,
        next: GET_TENANT_PROFILE,
        method: 'GET',
        authorization: true,
    }
});

export const resetProfile = (): AppNoApiAction => ({
    type: RESET_TENANT_PROFILE
});
